/**
 * @generated SignedSource<<2e70fc9c92e85942fa2ba0b08bee4eef>>
 * @relayHash c2729e34ecfb9542d89cbc2054efd8fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 92a99b2c1c8dd2c8f53891a1479eba53324c36973488f79bda3ef7677b9d3850

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceUpdateSmartSpaceOverviewInput = {
  spaceKey: string;
  summary?: ConfluenceUpdateSmartSpaceOverviewSummaryInput | null;
  topLinks?: ConfluenceUpdateSmartSpaceOverviewTopLinksInput | null;
};
export type ConfluenceUpdateSmartSpaceOverviewSummaryInput = {
  body?: string | null;
};
export type ConfluenceUpdateSmartSpaceOverviewTopLinksInput = {
  add?: ConfluenceAddTopLinkInput | null;
  edit?: ConfluenceEditTopLinkInput | null;
  remove?: ConfluenceRemoveTopLinkInput | null;
};
export type ConfluenceAddTopLinkInput = {
  isPinned?: boolean | null;
  title?: string | null;
  url: string;
};
export type ConfluenceEditTopLinkInput = {
  isPinned?: boolean | null;
  url: string;
};
export type ConfluenceRemoveTopLinkInput = {
  url: string;
};
export type TopLinksCardUpdateTopLinksMutation$variables = {
  cloudId: string;
  input: ConfluenceUpdateSmartSpaceOverviewInput;
};
export type TopLinksCardUpdateTopLinksMutation$data = {
  readonly confluence_updateSmartSpaceOverview: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly overview: {
      readonly topLinks: {
        readonly contentId: string | null;
        readonly lastRefreshed: AGG$DateTime | null;
        readonly links: ReadonlyArray<{
          readonly isPinned: boolean | null;
          readonly title: string | null;
          readonly url: string | null;
        } | null> | null;
      } | null;
    } | null;
    readonly success: boolean;
  } | null;
};
export type TopLinksCardUpdateTopLinksMutation = {
  response: TopLinksCardUpdateTopLinksMutation$data;
  variables: TopLinksCardUpdateTopLinksMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceUpdateSmartSpaceOverviewPayload",
    "kind": "LinkedField",
    "name": "confluence_updateSmartSpaceOverview",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "concreteType": "ConfluenceSmartSpaceOverview",
        "kind": "LinkedField",
        "name": "overview",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
            "kind": "LinkedField",
            "name": "topLinks",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "contentId"
              },
              {
                "kind": "ScalarField",
                "name": "lastRefreshed"
              },
              {
                "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                "kind": "LinkedField",
                "name": "links",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isPinned"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "title"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "url"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TopLinksCardUpdateTopLinksMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopLinksCardUpdateTopLinksMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c2729e34ecfb9542d89cbc2054efd8fb",
    "id": "92a99b2c1c8dd2c8f53891a1479eba53324c36973488f79bda3ef7677b9d3850",
    "metadata": {},
    "name": "TopLinksCardUpdateTopLinksMutation",
    "operationKind": "mutation",
    "text": "mutation TopLinksCardUpdateTopLinksMutation($cloudId:ID!,$input:ConfluenceUpdateSmartSpaceOverviewInput!){confluence_updateSmartSpaceOverview(cloudId:$cloudId,input:$input){success,errors{message},overview{topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}}"
  }
};
})();

(node as any).hash = "7c3c5220e6a36be3e1b0a3a57c4f0e9b";

export default node;
